/**
 * ADR 291 (movement-cost slice 4): the fewer-forklifts what-if — linear
 * capacity redistribution evaluated PER SHIFT-DAY, because a fleet is sized
 * by its peak day, not the period mean (design §5 B2). Deliberately client-
 * side and transparent: the server ships the raw histogram, this recomputes
 * instantly as the slider moves.
 *
 * Stated limits (rendered beside the result, never hidden): assumes work is
 * freely redistributable across the remaining trucks; ignores aisle
 * congestion and task deadlines.
 */

export interface ShiftDay {
  date: string;
  moveMs: number;
  shiftMs: number;
}

export interface WhatIfResult {
  /** Projected fleet utilization over the period, 0–100; null when the
   *  calendar contributed no shift time. */
  utilizationPct: number | null;
  /** Shift-days whose workload exceeds N × shift × target. */
  overflowDays: number;
  days: number;
  /** Hours beyond capacity across overflowing days. */
  overtimeHours: number;
}

export const CAPACITY_TARGET = 0.85;

export function whatIf(days: ShiftDay[], forklifts: number, target = CAPACITY_TARGET): WhatIfResult {
  const n = Math.max(1, forklifts);
  let move = 0, shift = 0, overflow = 0, overtimeMs = 0;
  for (const d of days) {
    move += d.moveMs;
    shift += d.shiftMs;
    const capacity = n * d.shiftMs * target;
    if (d.moveMs > capacity) {
      overflow++;
      overtimeMs += d.moveMs - capacity;
    }
  }
  return {
    utilizationPct: shift <= 0 ? null : Math.round((100 * move / (n * shift)) * 10) / 10,
    overflowDays: overflow,
    days: days.length,
    overtimeHours: Math.round((overtimeMs / 3_600_000) * 10) / 10,
  };
}
